import {FILTER_AND_SEARCH_REDUCER_STATE_ID} from './filter_and_search_constants';

export const getPrefixFromStateId = (stateId: string) => {
  return stateId
    ? `${stateId
        .replace(`${FILTER_AND_SEARCH_REDUCER_STATE_ID}_`, '')
        .toLowerCase()}`
    : '';
};
